import genericContentItem from '@shared/components/mixins/genericContentItem'

export default {
  name: 'ImageComponent',
  mixins: [genericContentItem],
  props: {
    isTarget: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSideImage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
